import axios from "axios";
import { QUARTERLY_ALL_ACTIONS_TYPE } from "../actions-type";

import { toast } from "react-toastify";
import { logoutAction } from "./auth";
import { apiRoot } from "../../apiRoot";

const API = axios.create({
  baseURL: `${apiRoot}/quarterly-target-plan`,
  withCredentials: true,
});
API.interceptors.request.use((req) => {
  if (localStorage.getItem("auth")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("auth")).AccessToken
    }`;
  }

  return req;
});

const refreshApi = axios.create({
  baseURL: `${apiRoot}/user/auth/refresh_token`,
  withCredentials: true,
});

const toastSuccess = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};
const toastError = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 2000,
    toastClassName: "custom-toast",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

const setLoadingQuarterlyTargetPlanAction = (loadingValue) => ({
  type: QUARTERLY_ALL_ACTIONS_TYPE.QUARTERLY_TARGET_PLAN_LOADING,
  payload: loadingValue,
});
const setCreateLoadingQuarterlyTargetPlanAction = (loadingValue) => ({
  type: QUARTERLY_ALL_ACTIONS_TYPE.QUARTERLY_TARGET_PLAN_CREATE_LOADING,
  payload: loadingValue,
});

export const getQuarterlyTargetPlanAction =
  (startDate, endDate, courseId) => async (dispatch) => {
    dispatch(setLoadingQuarterlyTargetPlanAction(true));

    try {
      const { data } = await API.get(
        `/?startDate=${startDate || ""}&endDate=${endDate || ""}&courseId=${
          courseId || ""
        }`,
      );
      dispatch({
        type: QUARTERLY_ALL_ACTIONS_TYPE.GET_QARTERLY_TARGET_PLAN,
        payload: data,
      });
    } catch (error) {
      console.log(error);

      if (error?.response?.status === 403) {
        dispatch(logoutAction());
      }
    } finally {
      dispatch(setLoadingQuarterlyTargetPlanAction(false));
    }
  };

export const createGroupAccordinglyQuarterlyTargetPlanAction =
  (newGroupData, startDate, endDate, courseId) => async (dispatch) => {
    dispatch({
      type: QUARTERLY_ALL_ACTIONS_TYPE.RESTE_QUARTERLY_TARGET_PLAN,
    });
    dispatch(setLoadingQuarterlyTargetPlanAction(true));
    try {
      const { data } = await API.post(
        `/add-new-group?startDate=${startDate || ""}&endDate=${endDate || ""}&courseId=${courseId}`,
        newGroupData,
      );

      dispatch({
        type: QUARTERLY_ALL_ACTIONS_TYPE.GET_QARTERLY_TARGET_PLAN,
        payload: data,
      });

      toastSuccess("Yeni qrup yaradıldı");
    } catch (error) {
      if (error?.response?.status === 403) {
        dispatch(logoutAction());
      }
      dispatch({
        type: QUARTERLY_ALL_ACTIONS_TYPE.RESTE_QUARTERLY_TARGET_PLAN,
      });
      toastError("Xəta baş verdi");
    } finally {
      dispatch(setLoadingQuarterlyTargetPlanAction(false));
    }
  };
